import { render, staticRenderFns } from "./goodsDetail.vue?vue&type=template&id=7d4cd5d5&scoped=true"
import script from "./goodsDetail.vue?vue&type=script&lang=js"
export * from "./goodsDetail.vue?vue&type=script&lang=js"
import style0 from "./goodsDetail.vue?vue&type=style&index=0&id=7d4cd5d5&prod&scoped=true&lang=css"
import style1 from "./goodsDetail.vue?vue&type=style&index=1&id=7d4cd5d5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d4cd5d5",
  null
  
)

export default component.exports